import * as TYPES from './constants';
import {API} from 'config/employer.config';
import {JWT_HEADER, JSON_HEADER} from 'config/srm.config';
import {
  resolveRopInstitutionUuidList,
  appendRecruitmentInstitutionUuidListParams,
} from 'utils/employerTalentRop';
import {
  clearRecruitmentInsightMetrix,
  requestRecruitmentInsightMetrix,
  receiveRecruitmentInsightMetrix,
  handleRecruitmentInsightMetrixError,
} from './actions';

const initialState = {
  data: null,
  error: false,
  request: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.RECRUITMENT_INSIGHT_METRIX_REQUEST:
      return {
        ...state,
        request: true,
      };
    case TYPES.RECRUITMENT_INSIGHT_METRIX_RECEIVE:
      return {
        ...state,
        data: action.payload,
        request: false,
      };
    case TYPES.RECRUITMENT_INSIGHT_METRIX_ERROR:
      return {
        ...state,
        error: true,
        request: false,
      };
    case TYPES.CLEAR_RECRUITMENT_INSIGHT_METRIX:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export const fetchRecruitmentInsightMetrics = () => (dispatch, getState) => {
  const {
    auth: {
      access: {token},
    },
  } = getState();
  const config = {
    mode: 'cors',
    method: 'GET',
    cache: 'default',
    headers: Object.assign({}, JWT_HEADER(token), JSON_HEADER),
  };
  dispatch(requestRecruitmentInsightMetrix());
  try {
    return resolveRopInstitutionUuidList(dispatch, getState, token)
      .then(ropList => {
        const url = appendRecruitmentInstitutionUuidListParams(
          API.administration.recruitment_Insight_Metrics,
          ropList
        );
        return fetch(url, config);
      })
      .then(response => response.json())
      .then(json => {
        dispatch(receiveRecruitmentInsightMetrix(json));
      })
      .catch(err => {
        console.log(err);
        dispatch(handleRecruitmentInsightMetrixError(err));
      });
  } catch (err) {
    console.log(err);
    dispatch(handleRecruitmentInsightMetrixError(err));
  }
};
